import type { SVGProps } from 'react';
const SvgNavHistoryFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={24}
    fill="none"
    width={24}
    {...props}
  >
    <path
      d="M8 17q.424 0 .713-.288A.97.97 0 0 0 9 16a.97.97 0 0 0-.287-.713A.97.97 0 0 0 8 15a.97.97 0 0 0-.713.287A.97.97 0 0 0 7 16q0 .424.287.712Q7.576 17 8 17m0-4q.424 0 .713-.287A.97.97 0 0 0 9 12a.97.97 0 0 0-.287-.713A.97.97 0 0 0 8 11a.97.97 0 0 0-.713.287A.97.97 0 0 0 7 12q0 .424.287.713Q7.576 13 8 13m0-4q.424 0 .713-.287A.97.97 0 0 0 9 8a.97.97 0 0 0-.287-.713A.97.97 0 0 0 8 7a.97.97 0 0 0-.713.287A.97.97 0 0 0 7 8q0 .424.287.713Q7.576 9 8 9m3 8h6v-2h-6zm0-4h6v-2h-6zm0-4h6V7h-6zM5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587Q21 4.176 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21z"
      fill="currentColor"
    />
  </svg>
);
export default SvgNavHistoryFilled;
